import dayjs from "dayjs";
import { roundUp, formatDate } from "./helpers";

export function generateBaseSchedule({
  loanAmount,
  monthlyRate,
  loanTerm,
  startDate,
  monthlyPayment,
}) {
  let balance = loanAmount;
  let paymentDate = startDate;
  let totalInterest = 0;
  const schedule = [];

  for (let i = 1; i <= loanTerm; i++) {
    if (i > 1) paymentDate = paymentDate.add(1, "month");

    const year = paymentDate.year();
    const month = paymentDate.month();

    const adjustedDay = month === 1 ? 28 : 30;
    paymentDate = dayjs(`${year}-${month + 1}-${adjustedDay}`, "YYYY-M-D");

    const interest = balance * monthlyRate;
    const capital = monthlyPayment - interest;
    balance -= capital;
    if (balance < 0) balance = 0;

    totalInterest += interest;

    schedule.push({
      cuota: i,
      payment: false,
      fechaPago: formatDate(paymentDate),
      valorPrestamo: balance + capital,
      cuotaAPagar: roundUp(monthlyPayment),
      capital: roundUp(capital),
      interes: roundUp(interest),
      saldoDeuda: roundUp(balance),
    });
  }

  return { schedule, totalInterest };
}
